<template>
  <el-dialog v-model="mainPopupItem.openpopup2" title="Add Device" :before-close="close" draggable top="20%">

    <el-form :model="mainPopupItem" :rules="rules" ref="formModel" label-width="150px">


      <el-form-item label="Device" style="font-family:Rajdhani" prop="title">
        <el-input v-model="mainPopupItem.title"></el-input>
      </el-form-item>

      <el-form-item label="Selected" style="font-family:Rajdhani"  prop="selected">
        <el-switch v-model="mainPopupItem.selected" active-color="#13ce66" inactive-color="#f2f2f2" ></el-switch>
      </el-form-item>
      <el-form-item label="Quantity" style="font-family:Rajdhani" prop="quantity">
        <el-input-number v-model="mainPopupItem.quantity" type="number" ></el-input-number>
      </el-form-item>
      <el-form-item label="Backup_Duration" style="font-family:Rajdhani" prop="backup_Duration">
        <el-input v-model="mainPopupItem.backup_Duration" type="number" ></el-input>
      </el-form-item>

      <el-form-item  label="Nominal Power" style="font-family:Rajdhani" prop="nominal_Power">
        <el-input v-model="mainPopupItem.nominal_Power" type="number"></el-input>
      </el-form-item>

      <el-form-item  label="Unit" style="font-family:Rajdhani" prop="unit">
        <el-select v-model="mainPopupItem.unit" placeholder="Please select" style="width: 100%">
          <el-option v-for="item in unitOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="submitForm" style="margin: 0 20px 0 auto; font-family:Rajdhani">Submit</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
  
<script>

import { ref } from 'vue';
import { ElForm, ElFormItem, ElInput, ElButton } from 'element-plus';
import { toRefs,reactive } from "@vue/reactivity";


export default {

  props: ["name"],

  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
  },
  setup(props, context) {
    console.log("props===", props);
    console.log("context===", context);
    const mainPopupItem = toRefs(props).name;

    const formModel = ref({
      title: '',
      backup_Duration: '',
      selected: '',
      quantity: '',
      unit: '',
      nominal_Power: ''
    });

    let validateNomPower = (_rule, value) => {
      if (value === 0) {
        return Promise.reject('Please enter your nominal_Power');
      } else {
        return Promise.resolve();
      }
    };

    let validateQuantity = (_rule, value) => {
      if (value === 0) {
        return Promise.reject('Please enter your quantity');
      } else {
        return Promise.resolve();
      }
    };

    let validateSelected = (_rule, value) => {
      console.log("value::",value)
      if (value === false) {
        return Promise.reject('Please enter your quantity');
      } else {
        return Promise.resolve();
      }
    };

    

    const rules = ref({
      title: [{ required: true, message: 'Please enter your title', title: 'change' }],
      backup_Duration: [{ required: true, message: 'Please enter your duration', trigger: 'change' }],
      selected: [{ required: true, validator: validateSelected, message: 'Please enter your selected', trigger: 'change' }],
      quantity: [{ required: true, validator: validateQuantity, message: 'Please enter your quantity', trigger: 'change' }],
      unit: [{ required: true, message: 'Please enter your unit', trigger: 'change' }],
      nominal_Power: [{ required: true, validator: validateNomPower, message: 'Please enter your nominal_Power', trigger: 'change' }],
    });

    const submitForm = () => {
      // Validate the form before submitting
      const formRef = formModel.value;
      console.log("submit mainPopupItem::",mainPopupItem)
      console.log("submit mainPopupItem.value::",mainPopupItem.value.popupdropdown)
  
      formRef.validate((valid) => {
        if (valid) {
          mainPopupItem.value.openpopup2 = false

          
        } else {
          console.log('Form is invalid. Please check the fields.');
        }
      });
    };

    const unitOptions = reactive([{ value: '', label: 'Selected' }, { value: 'Ton', label: 'Ton' }, { value: 'Hp', label: 'Hp' }, { value: 'W', label: 'W' }]);

    return {
      formModel,
      rules,
      submitForm,
      mainPopupItem,
      unitOptions
    };
  },
};
</script>